import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { Reveal } from "./Reveal";

export const RoyalTitleOfDay = () => {
  const [title, setTitle] = React.useState(null);

  React.useEffect(() => {
    api.get("/royal-titles/title-of-the-day").then((r) => setTitle(r.data)).catch(() => {});
  }, []);

  if (!title) return null;

  return (
    <section className="bg-night text-cream" data-testid="royal-title-of-day-section">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <Reveal>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-gold/30 bg-gradient-to-br from-forest/40 to-night-surface p-8 md:p-10 overflow-hidden"
            data-testid="royal-title-of-day-card"
          >
            <div className="flex items-center gap-2 mb-5">
              <Crown className="w-4 h-4 text-gold" />
              <p className="uppercase tracking-[0.25em] text-xs text-gold-soft">Royal Title of the Day</p>
              {title.region && (
                <span className="text-[10px] uppercase tracking-widest border border-cream/25 rounded-full px-2.5 py-0.5 text-cream/60">
                  {title.region}
                </span>
              )}
            </div>

            <p className="text-[11px] uppercase tracking-[0.25em] text-gold-soft mb-1" data-testid="royal-title-of-day-town">
              {title.town}
            </p>
            <h3 className="font-serif text-4xl md:text-5xl text-gold leading-tight mb-4" data-testid="royal-title-of-day-title">
              {title.title}
            </h3>
            {title.note && (
              <p className="text-cream/80 text-lg leading-relaxed mb-8 max-w-2xl">{title.note}</p>
            )}

            <Link
              to="/royal-titles"
              data-testid="royal-title-of-day-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
            >
              Explore all royal titles
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default RoyalTitleOfDay;
